export const firebaseConfig = {
  apiKey: "AIzaSyD4KIcbR5u37ztnbmHf-WloCjIXRIn3IUg",
  authDomain: "ourlinkedlives.firebaseapp.com",
  projectId: "ourlinkedlives",
  storageBucket: "ourlinkedlives.appspot.com",
  messagingSenderId: "36400973687",
  appId: "1:36400973687:web:84bdd9da3cd9b2c4090372",
  measurementId: "G-HQNDHY9001",
};